import StaticPropsContext, { StaticPropsProvider, StaticPropsConsumer } from './static-props';
import withStaticProps from './with-static-props';

export default StaticPropsContext;
export { StaticPropsProvider, StaticPropsConsumer, withStaticProps };
